import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  return (
    <div className="flex flex-wrap gap-3 justify-center mb-12">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`group relative px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
            activeCategory === category.id
              ? 'bg-primary text-primary-foreground shadow-premium'
              : 'bg-card text-foreground hover:bg-muted border border-border'
          }`}
        >
          <div className="flex items-center space-x-2">
            <Icon 
              name={category.icon as any} 
              size={20} 
              className={activeCategory === category.id ? 'text-primary-foreground' : 'text-primary'}
            />
            <span>{category.name}</span>
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              activeCategory === category.id
                ? 'bg-primary-foreground/20 text-primary-foreground'
                : 'bg-primary/10 text-primary'
            }`}>
              {category.count}
            </span>
          </div>
          {activeCategory === category.id && (
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-xl -z-10"></div>
          )}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;